import { gql } from '@apollo/client';
import { Products } from '../../fragments/product/products.fragments';

const QUERY_PRODUCT = gql`
  query GetSingleProduct($id: ID!) {
    produit(id: $id) {
      data {
        id
        attributes {
          ...MainProducts
          ingredients {
            name
            id
            percent
          }
          allergens {
            id
            name
          }
          shoppingMobile {
            id
            description
            mobile
          }
        }
      }
    }
  }
  ${Products.fragments.main}
`;
export default QUERY_PRODUCT;
